import { AdminLayout } from "@/views/layouts/AppLayout";
import { SupplierPage } from "@/views/pages/supplierManagement/SupplierPage";
import { SupplierDetailPage } from "@/views/pages/supplierManagement/SupplierDetailPage";
import { SupplierFormPage } from "@/views/pages/supplierManagement/SupplierFormPage";
import { GroupCompanyPage } from "@/views/pages/supplierManagement/GroupCompanyPage";
import type { AdminRouteObject } from "../index";

/** 供应商管理路由，保留 Vue 列表及历史详情/表单入口。 */
export const supplierManagementRoutes: AdminRouteObject = {
    path: "/supplierManagement",
    element: <AdminLayout />,
    handle: { title: "供应商管理" },
    children: [
        {
            path: "enterpriseManage",
            element: <SupplierPage />,
            handle: { title: "供应商管理", permissions: ["ROLE_SUPPLIER_R", "ROLE_SUPPLIER_DEAL"] }
        },
        {
            path: "enterpriseManage/detail",
            element: <SupplierDetailPage />,
            handle: { title: "供应商详情", permissions: ["ROLE_SUPPLIER_R", "ROLE_SUPPLIER_DEAL"] }
        },
        {
            path: "enterpriseManage/add",
            element: <SupplierFormPage />,
            handle: { title: "新增供应商", permissions: ["ROLE_SUPPLIER_DEAL"] }
        },
        {
            path: "enterpriseManage/edit",
            element: <SupplierFormPage />,
            handle: { title: "修改供应商", permissions: ["ROLE_SUPPLIER_DEAL"] }
        },
        {
            path: "cliqueManage",
            element: <GroupCompanyPage />,
            handle: { title: "集团管理", permissions: ["ROLE_SUPPLIER_R", "ROLE_SUPPLIER_DEAL"] }
        }
    ]
};

export default supplierManagementRoutes;
